import type { CatalogProvider, CatalogSyncAction } from "./integration-catalog.js";
import { isOrderSourceProvider } from "./onboarding-connection-groups.js";

export interface ImportRetryTarget {
  platform: string;
  providerLabel: string;
  actionId: string;
  actionLabel: string;
}

/**
 * Pick only safe, ordinary order-import actions for automatic recovery.
 * Full-history actions stay manual because they can be expensive and the
 * Connections screen already asks for confirmation before starting them.
 */
export function selectSafeImportRetryTargets(
  providers: CatalogProvider[],
  activePlatforms: ReadonlySet<string>,
): ImportRetryTarget[] {
  return providers.flatMap((provider) => {
    if (!activePlatforms.has(provider.platform) || !isOrderSourceProvider(provider)) return [];
    const action = provider.syncActions.find((candidate) => candidate.primary && !candidate.heavy)
      ?? provider.syncActions.find((candidate) => !candidate.heavy);
    return action ? [toTarget(provider, action)] : [];
  });
}

function toTarget(provider: CatalogProvider, action: CatalogSyncAction): ImportRetryTarget {
  return {
    platform: provider.platform,
    providerLabel: provider.label,
    actionId: action.id,
    actionLabel: action.label,
  };
}
